var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-wrapper",class:{isError: _vm.error}},[(_vm.label)?_c('label',{staticClass:"label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "+_vm._s(_vm.required ? ' *' : '')+"\n  ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }